<template>
  <Modal
    :title="title"
    width="520"
    v-model="state"
    @on-visible-change="bindGetData"
    :transfer="false"
    :z-index="99"
    :mask-closable="false"
    class-name="vertical-center-modal"
  >
    <Spin size="large" fix v-if="loading"></Spin>
    <Row class="row-item">
      <Col span="6" class="col-item">
        <span class="item-field">媒体</span>
      </Col>
      <Col span="18" offset="1">
        <RadioGroup v-model="media" type="button">
          <Radio :label="10" :disabled="10 !== media">巨量引擎</Radio>
          <Radio :label="16" :disabled="16 !== media">腾讯</Radio>
          <!-- <Radio :label="6" :disabled="6 !== media">UC新闻</Radio> -->
          <!-- <Radio :label="45" :disabled="45 !== media">百度</Radio> -->
        </RadioGroup>
      </Col>
    </Row>
    <Row class="row-item">
      <Col span="6" class="col-item">
        <span class="item-field">复制{{ routeName }}</span>
      </Col>
      <Col span="12" offset="1" style="overflow-x: hidden; text-overflow: ellipsis">
        <span style="font-size: 14px; white-space: nowrap" :title="!!data ? data.adName : '计划数据有误，请联系系统管理员!'">
          {{ !!data ? data.adName : '计划数据有误，请联系系统管理员!' }}
        </span>
      </Col>
    </Row>
    <Row class="row-item">
      <Col span="6" class="col-item">
        <span class="item-field">账号</span>
      </Col>
      <Col span="12" offset="1">
        <auto-complete
          v-model="account"
          :data="accountData"
          disabled
          placeholder="请选择账号"
          @on-select="handleAccount"
          style="width: 250px"
        />
      </Col>
    </Row>
    <Row class="row-item">
      <Col span="6" class="col-item">
        <span class="item-field">{{ routeName }}</span>
      </Col>
      <Col span="12" offset="1">
        <auto-complete
          v-model="campaign"
          :data="campaignData"
          :placeholder="`请选择${routeName}`"
          @on-select="handleCampaign"
          style="width: 250px"
        />
      </Col>
    </Row>

    <Row slot="footer" :gutter="12">
      <Button type="default" @click="cancel">取消</Button>
      <Button type="primary" @click="save">确定</Button>
    </Row>
  </Modal>
</template>
<script>
import { adAccount } from '@/api/common.model'
import { queryGroupByAccountWithBudget } from '@/api/toutiao.local.model'
import { existWechatAd } from '@/api/tencent.model'
import { setLocalInfo, isArray } from '@/common/js/utils'
import AutoComplete from '@/components/autocomplete/autocomplete.vue'
export default {
  name: 'CopyPlanModal',
  components: { AutoComplete },
  props: {
    title: {
      type: String
    },
    value: {
      type: Boolean
    },
    media: {
      type: [Number, String]
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    mediaHtml() {
      let name = ''
      if (this.media === 10) name = 'create/toutiaocopy'
      else if (this.media === 6) name = 'create/uc'
      else if (this.media === 16) name = 'create/tencentcopy'
      else if (this.media === 45) name = 'create/baidu'
      return name
    },
    mediaRoutes() {
      let route = []
      if (this.media === 10) route = 'plan'
      else if (this.media === 16) route = 'plan'
      else if (this.media === 6) route = 'unit_copy'
      else if (this.media === 45) route = 'unit_copy'
      return route
    },
    routeName() {
      let name = []
      if (this.media === 10) name = '计划组'
      else if (this.media === 16) name = '推广计划'
      else if (this.media === 6) name = '计划组'
      else if (this.media === 45) name = '推广计划'
      return name
    }
  },
  methods: {
    bindGetData(val) {
      // 显示状态
      if (val) {
        if (this.data && this.data.adInfo) {
          const adInfo = JSON.parse(this.data.adInfo)
          this.adInfo = adInfo
          if (this.media === 10) this.promotedObjecType = adInfo.landing_type
          else if (this.media === 16) this.promotedObjecType = adInfo.promoted_object_type
        }
        if (!this.accountStat) {
          this.getAdAccount()
          if (this.data) this.getAdCampaign(this.data.adAccountId, true)
        } else if (this.data) {
          this.account = this.data.adAccountId
          this.accountName = this.data.adAccountName
          if (this.data) this.getAdCampaign(this.data.adAccountId, true)
        }
      } else {
        this.account = ''
        this.campaign = ''
      }
    },
    getAdAccount(init = false) {
      this.loading = true
      adAccount({
        mediaId: this.$store.state.Convert.media,
        authFlag: 1
      }).then((data) => {
        this.loading = false
        this.accountStat = true
        if (data && isArray(data)) {
          this.accountData = data
          if (this.data) {
            this.account = this.data.adAccountId
            this.accountName = this.data.adAccountName
          }
        }
      })
    },
    getAdCampaign(id, init = false) {
      this.loading = true
      queryGroupByAccountWithBudget({
        adAccountId: id,
        promotedObjecType: this.promotedObjecType
      }).then((data) => {
        this.loading = false
        this.campaign = ''
        if (data && isArray(data)) {
          this.campaignData = data.map((ret) => {
            return {
              id: ret.adGroupId,
              name: ret.adGroupName
            }
          })
          if (this.data && init) {
            this.campaign = this.data.adGroupId
          }
        }
      })
    },
    handleAccount(meta) {
      if (!meta.id) return
      this.account = meta.id
      this.accountName = meta.name
      this.getAdCampaign(this.account)
    },
    handleCampaign(meta) {
      if (!meta.id) return
      this.campaign = meta.id
    },
    async save() {
      // 验证广告账号
      if (!this.account) {
        this.$Message.error({
          duration: 5,
          content: '未选择计划账号'
        })
        return
      }
      // 验证广告组
      if (!this.campaign) {
        this.$Message.error({
          duration: 5,
          content: `未选择${this.routeName}`
        })
        return
      }
      if (!this.data) {
        this.$Message.error({
          duration: 5,
          content: '计划数据有误，请联系系统管理员!'
        })
        return
      }
      const res = await this.checkCampaign()
      console.log(res)
      if (!res.isOk) {
        this.$Message.error({
          duration: 5,
          content: res.msg
        })
        return
      }
      // 投放计划新建
      this.cancel()
      const params = `ad=${this.data.adId}&accountId=${this.data.adAccountId}&campaignId=${this.data.adGroupId}`
      window.open(`/${this.mediaHtml}/${this.mediaRoutes}/${this.campaign}/?${params}`, '_blank')
    },
    cancel() {
      setLocalInfo(this.account, this.accountName, this.media)
      this.$emit('on-cancel')
    },
    async checkCampaign() {
      const site_set = this.adInfo.site_set
      // 查是否为仅朋友圈广告组
      const campaigns = [
        {
          ad_account_id: this.account,
          campaign_id: this.campaign
        }
      ]
      let existWechat = false
      let planCountsZero = false
      this.loading = true
      await existWechatAd({ campaigns }).then((data) => {
        this.loading = false
        existWechat = data.some((ret) => ret.exist)
        planCountsZero = data.some((ret) => ret.planCounts === 0)
      })
      if (site_set && site_set.includes('SITE_SET_MOMENTS')) {
        return {
          isOk: existWechat || planCountsZero,
          msg: existWechat || planCountsZero ? '' : '目标推广计划不符合复制条件请选择仅朋友圈的推广计划'
        }
      } else {
        return {
          isOk: !existWechat,
          msg: !existWechat ? '' : '目标推广计划不符合复制条件请选择无朋友圈的推广计划'
        }
      }
    }
  },
  data() {
    return {
      loading: null,
      accountStat: false,
      accountData: [], // 广告账号
      account: '',
      campaignData: [], // 广告组
      campaign: '',
      planData: [], // 投放计划
      planId: '', // 内部计划
      adInfo: {}, // 计划详细信息
      promotedObjecType: '' // 推广目的
    }
  }
}
</script>
